import styled from 'styled-components'

// Click-to-select highlighted rows have no DS list primitive — selected
// state uses the theme's selection tint + brand border (draft parity).
export const SelectableRowStyled = styled.div<{ $selected: boolean }>`
  padding: ${({ theme }) => `${theme.space.medium} ${theme.space.small}`};
  border-bottom: 1px solid ${({ theme }) => theme.colors.content.border};
  border-left: 3px solid
    ${({ theme, $selected }) => ($selected ? theme.colors.info : 'transparent')};
  background: ${({ theme, $selected }) =>
    $selected ? theme.colors.selected : 'transparent'};
  cursor: pointer;
`
